/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdCommonModule, MdRippleModule, StyleModule} from '../core';
import {
  MdAnchor,
  MdButton,
  MdMiniFab,
  MdButtonCssMatStyler,
  MdFab,
  MdIconButtonCssMatStyler,
  MdRaisedButtonCssMatStyler
} from './button';


export {MdButtonCssMatStyler,MdRaisedButtonCssMatStyler,MdIconButtonCssMatStyler,MdFab,MdMiniFab,MdButtonBase,_MdButtonMixinBase,MdButton,MdAnchor} from './button';
export class MdButtonModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdRippleModule,
    MdCommonModule,
    StyleModule,
  ],
  exports: [
    MdButton,
    MdAnchor,
    MdMiniFab,
    MdFab,
    MdCommonModule,
    MdButtonCssMatStyler,
    MdRaisedButtonCssMatStyler,
    MdIconButtonCssMatStyler,
  ],
  declarations: [
    MdButton,
    MdAnchor,
    MdMiniFab,
    MdFab,
    MdButtonCssMatStyler,
    MdRaisedButtonCssMatStyler,
    MdIconButtonCssMatStyler,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
MdButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdButtonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
